var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "h-100", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        { staticClass: "h-100 no-overflow", attrs: { id: "client-portal" } },
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex flex-column",
              attrs: { id: "one-side-login", cols: "12", lg: "5" },
            },
            [
              _c(
                "b-row",
                { staticClass: "mt-4 justify-content-center" },
                [
                  _c("b-col", { attrs: { cols: "auto" } }, [
                    _c("div", { staticClass: "logo logo-login mt-5" }, [
                      _c(
                        "a",
                        {
                          staticClass: "text-right",
                          attrs: { href: "#/login" },
                        },
                        [
                          _c("img", {
                            staticClass: "logo-img",
                            attrs: {
                              src: _vm.$options.filters.getLogo(),
                              alt: "",
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                {
                  staticClass:
                    "justify-content-center align-items-center h-100",
                },
                [
                  _c(_vm.page, {
                    tag: "component",
                    attrs: { email: _vm.emailReset },
                    on: { "next-page": _vm.handleNextPage },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", {
            staticClass: "ellipse-left-in d-none d-md-block",
            attrs: { id: "two-side-login", cols: "12", lg: "7" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }